import { Navigate, RouteObject } from "react-router";
import Login from "../../Login/Login";

import Registreringsflyt from "../../Registreringsflyt/Registreringsflyt";
import ProtectedRoutes from "./ProtectedRoutes";
import { InfoPage } from "../../InfoPage/InfoPage";
import VelgVirksomhet from "../../VelgVirksomhet/VelgVirksomhet";
import KontaktinfoWrapper from "../../Kontaktinfo/KontaktinfoWrapper";
import { AvtaleVilkaar } from "../../PartnerOnboarding/AvtaleVilkaar/AvtaleVilkaar";
import { RegistreringsFlytOppsummering } from "../../Oppsummering/RegistreringsFlytOppsummering";
import { Fullmakt } from "../../PartnerOnboarding/Fullmakt/Fullmakt";
import ManuellRegistreringKontaktinfo from "../../ManuellRegistreringKontaktinfo/ManuellRegistreringKontaktinfo";
import FerdigManuell from "../../FerdigManuell/FerdigManuell";
import { ManuellRegistreringsflytOppsummering } from "../../Oppsummering/ManuellRegistreringsflytOppsummering";
import ManuellRegistreringsflyt from "../../ManuellRegistreringsflyt/ManuellRegistreringsflyt";
import { ManuellFullmakt } from "../../PartnerOnboarding/Fullmakt/ManuellFullmakt";
import { Route, RouteHandle } from "./routes";

function defaultRedirect(to: string | string[]): RouteObject {
  const target = typeof to === "string" ? to : to.join("/");

  return {
    index: true,
    element: <Navigate to={target} replace />,
  };
}

function titleHandle(title: string): { handle: RouteHandle } {
  return { handle: { title } };
}

const commonRoutes: RouteObject[] = [
  {
    path: "info",
    element: <InfoPage />,
    ...titleHandle("Bli kunde"),
  },
  {
    path: "login",
    element: <Login />,
    ...titleHandle("Innlogging"),
  },
];

const registreringSteps = ["velg-virksomhet", "kontaktinfo", "oppsummering"];
const manuellRegistreringSteps = ["kontaktinfo", "oppsummering", "ferdig"];

const registreringRoutes: RouteObject[] = [
  defaultRedirect([Route.Registrering, registreringSteps[0]]),
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: Route.Registrering,
        element: <Registreringsflyt steps={registreringSteps} />,
        children: [
          defaultRedirect(registreringSteps[0]),
          {
            path: registreringSteps[0],
            element: <VelgVirksomhet />,
            ...titleHandle("Velg virksomhet"),
          },
          {
            path: registreringSteps[1],
            element: <KontaktinfoWrapper />,
            ...titleHandle("Kontaktinformasjon"),
          },
          {
            path: registreringSteps[2],
            element: <RegistreringsFlytOppsummering />,
            ...titleHandle("Oppsummering"),
          },
        ],
      },
      {
        element: <ManuellRegistreringsflyt steps={manuellRegistreringSteps} />,
        path: Route.Manuell,
        children: [
          defaultRedirect(manuellRegistreringSteps[0]),
          {
            path: manuellRegistreringSteps[0],
            element: <ManuellRegistreringKontaktinfo />,
            ...titleHandle("Kontaktinformasjon - manuell registrering"),
          },
          {
            path: manuellRegistreringSteps[1],
            element: <ManuellRegistreringsflytOppsummering />,
            ...titleHandle("Oppsummering - manuell registrering"),
          },
          {
            path: manuellRegistreringSteps[2],
            element: <FerdigManuell />,
            ...titleHandle("Ferdig - manuell registrering"),
          },
        ],
      },
    ],
  },
];

const partnerOnboardingSteps = [
  "velg-virksomhet",
  "kontaktinfo",
  "fullmakt",
  "avtalevilkaar",
  "oppsummering",
];

const manuellPartnerOnboardingSteps = [
  "kontaktinfo",
  "fullmakt",
  "oppsummering",
  "ferdig",
];

const partnerOnboardingRoutes: RouteObject[] = [
  {
    path: Route.PartnerOnboarding,
    element: <ProtectedRoutes partnerOnboardingRoute />,
    children: [
      defaultRedirect([Route.Registrering, partnerOnboardingSteps[0]]),
      {
        path: Route.Registrering,
        element: <Registreringsflyt steps={partnerOnboardingSteps} />,
        children: [
          defaultRedirect(partnerOnboardingSteps[0]),
          {
            path: partnerOnboardingSteps[0],
            element: <VelgVirksomhet />,
            ...titleHandle("Velg virksomhet - partneronboarding"),
          },
          {
            path: partnerOnboardingSteps[1],
            element: <KontaktinfoWrapper />,
            ...titleHandle("Kontaktinformasjon - partneronboarding"),
          },
          {
            path: partnerOnboardingSteps[2],
            element: <Fullmakt />,
            ...titleHandle("Fullmakt - partneronboarding"),
          },
          {
            path: partnerOnboardingSteps[3],
            element: <AvtaleVilkaar />,
            ...titleHandle("Avtalevilkår - partneronboarding"),
          },
          {
            path: partnerOnboardingSteps[4],
            element: <RegistreringsFlytOppsummering />,
            ...titleHandle("Oppsummering - partneronboarding"),
          },
        ],
      },
      {
        element: (
          <ManuellRegistreringsflyt steps={manuellPartnerOnboardingSteps} />
        ),
        path: Route.Manuell,
        children: [
          defaultRedirect(manuellPartnerOnboardingSteps[0]),
          {
            path: manuellPartnerOnboardingSteps[0],
            element: <ManuellRegistreringKontaktinfo />,
            ...titleHandle("Kontaktinfo - manuell partneronboarding"),
          },
          {
            path: manuellPartnerOnboardingSteps[1],
            element: <ManuellFullmakt />,
            ...titleHandle("Fullmakt - manuell partneronboarding"),
          },
          {
            path: manuellPartnerOnboardingSteps[2],
            element: <ManuellRegistreringsflytOppsummering />,
            ...titleHandle("Oppsummering - manuell partneronboarding"),
          },
          {
            path: manuellPartnerOnboardingSteps[3],
            element: <FerdigManuell />,
            ...titleHandle("Ferdig - manuell partneronboarding"),
          },
        ],
      },
    ],
  },
];

export default [
  ...commonRoutes,
  ...registreringRoutes,
  ...partnerOnboardingRoutes,
];
